import {createRequestDataSource} from '@ngneat/elf-requests';
import {selectAllEntities} from '@ngneat/elf-entities';

import {serviceKindsStore} from '@store/settings/serviceKinds/serviceKinds.store';

export const getServiceKindDataSource = createRequestDataSource({
  store: serviceKindsStore,
  data$: () => serviceKindsStore.pipe(
    selectAllEntities(),
  ),
  requestKey: 'getServiceKinds',
  dataKey: 'serviceKinds',
});